export default __webpack_public_path__ + "static/media/save.c65ab3fc.svg";